import { Grid, Link, Typography } from '@material-ui/core';
import React from 'react';
import Logo from '../../common/components/Logo';

const AppDownload = () => {
  return (
    <Grid container direction='column' alignItems='center' spacing={4}>
      <Grid item>
        <Logo />
      </Grid>
      <Grid container item direction='column' alignItems='center'>
        <Typography variant='h6'>
          Download our app to view this content.
        </Typography>
        <Link href=''>
          <img src='/assets/Google_Play.png' alt='Get it on Google Play' />
        </Link>
        <Link href=''>
          <img src='/assets/App_Store.png' alt='Available on the App Store' />
        </Link>
      </Grid>
    </Grid>
  );
};

export default AppDownload;
